module.exports = __webpack_public_path__ + "static/img/logo_34.3a00de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_34.png
// module id = NJhu
// module chunks = 1